import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Tappable } from '@vectord/components';
import cogoToast from 'cogo-toast';

import { useUpdateSbatGroupLessonMutation } from '@classCreation/services/sbatGroupLessonService';
import { classTagSelector } from '@classCreation/selectors/createClassForm';
import ClassTagField from '../ClassTagField';
import FieldErrors from 'components/FieldErrors';
import Form from 'components/Form';
import LessonInput from '../LessonInput';
import useSbatGroupConfirmation from '@classCreation/hooks/useSbatGroupConfirmation';

export default function EditSbatGroupLessonForm({
  isEditing,
  setIsEditing,
  sbatGroup,
  value,
  label,
  classTagValue,
}) {
  const classTagState = useSelector(classTagSelector);

  const [lesson, setLesson] = useState(value);
  const [updateLesson, { isSuccess, error, isLoading: isUpdating, reset }] =
    useUpdateSbatGroupLessonMutation();

  const handleEditLesson = useCallback(() => {
    updateLesson({
      sbatGroupId: sbatGroup.id,
      lesson,
      classTag: classTagState,
    });
  }, [classTagState, lesson, sbatGroup.id, updateLesson]);

  const handleSubmit = useSbatGroupConfirmation(handleEditLesson, sbatGroup);

  useEffect(() => {
    if (!isEditing) {
      setLesson(value);
      if (error) {
        reset();
      }
    }
  }, [error, isEditing, reset, value]);

  const handleOnChange = useCallback((newLesson) => {
    setLesson(newLesson);
  }, []);

  useEffect(() => {
    if (isSuccess) {
      cogoToast.success('Lesson is successfully updated!');
      setIsEditing(false);
    }
    if (error) {
      cogoToast.error(
        error?.data?.message ||
          'There was some problem in updating the lesson. Please try again later!'
      );
    }
  }, [error, isSuccess, setIsEditing]);

  return (
    <Form onSubmit={handleSubmit}>
      <LessonInput
        lessonType={value.lesson_type}
        value={lesson}
        onChange={handleOnChange}
        disabled={!isEditing}
        className="m-b-xs"
      />
      {classTagValue && value.lesson_type === 'live_lecture' && (
        <ClassTagField
          classTag={classTagValue}
          isEditing={isEditing}
        />
      )}
      <FieldErrors
        name="duration"
        errors={error?.data?.errors}
      />
      <FieldErrors
        name="test_id"
        errors={error?.data?.errors}
      />
      {isEditing && (
        <Tappable
          className="btn btn-primary"
          disabled={isUpdating}
          component="button"
          type="submit"
        >
          Update {label}
        </Tappable>
      )}
    </Form>
  );
}
